export const ADMIN_ROUTES = {
	ROOT: "/admin",
	DASHBOARD: "/admin/dashboard",
	ANALYTICS: "/admin/analytics",
	API_KEYS: "/admin/api-keys",
	COMMUNITY: "/admin/community",
	MEMBERS: "/admin/members",
	GROUPS: "/admin/groups",
	SPONSORSHIP: "/admin/sponsorship",
	WEBHOOKS: "/admin/webhooks",
	WEBHOOK_DETAIL: "/admin/webhooks/:webhookId",
} as const;

export const buildWebhookDetailRoute = (webhookId: string) => `/admin/webhooks/${webhookId}`;
